/* Zuschnitt aus bei Stil-Produkten 12.10.2026 (Theme-Kopie PMP ZUSCHNITT 1210).
   Bei einem gewählten Stil mit Stil-Ebene (alles außer "Original, ohne Stil") wirkt "Ausschnitt ändern" weder in der Vorschau
   noch im Druck, und der Dialog zeigt ein Beispielfoto statt des Kundenfotos. Dann wird der Knopf per CSS ausgeblendet
   (body.pmp-stil-aktiv) und der Dialog, der nach dem Upload von selbst aufgeht, still mit "Speichern" geschlossen.
   Bei "Original, ohne Stil", ohne gewählten Stil und bei Produkten ohne Stil-Auswahl bleibt alles wie es ist. */
(() => {
  'use strict';
  if (window.__pmpZuschnitt) return;
  window.__pmpZuschnitt = true;
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();
  let uploadTs = 0, autoTimer = 0;

  const stilSelect = () => [...document.querySelectorAll('.tee-form-wrapper .tee-field--template')].filter((f) =>
    !f.classList.contains('sr-only') && /^Stil/i.test(norm((f.querySelector('.tee-field__heading') || {}).textContent)))
    .map((f) => f.querySelector('select')).find(Boolean) || null;

  const aktiv = () => {
    const s = stilSelect();
    if (!s || s.selectedIndex < 1) return false;
    const t = norm(s.options[s.selectedIndex].textContent);
    return !!t && !/^Original/i.test(t) && !/wählen|choose/i.test(t);
  };

  const sync = () => {
    const a = aktiv();
    if (document.body.classList.contains('pmp-stil-aktiv') !== a) document.body.classList.toggle('pmp-stil-aktiv', a);
  };

  const dialog = () => document.querySelector('.tee-dialog-image-placement');
  const speichern = (d) => [...d.querySelectorAll('button')].find((b) => /^(Speichern|Save)$/i.test(norm(b.textContent)));

  const autoSchliessen = () => {
    const d = dialog();
    if (!d || autoTimer || !aktiv() || Date.now() - uploadTs > 20000) return;
    document.body.classList.add('pmp-auto-zu');
    let n = 0;
    autoTimer = setInterval(() => {
      const dd = dialog();
      const b = dd && speichern(dd);
      if (!dd || ++n > 12) { // geschlossen, oder nach ~3 s aufgeben: Dialog dann sichtbar lassen
        clearInterval(autoTimer); autoTimer = 0;
        document.body.classList.remove('pmp-auto-zu');
        return;
      }
      if (b && !b.disabled) b.click();
    }, 250);
  };

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.tagName === 'INPUT' && t.type === 'file' && t.closest('.tee-form-wrapper')) uploadTs = Date.now();
    sync();
  }, true);

  let wartet = false;
  new MutationObserver(() => {
    if (wartet) return;
    wartet = true;
    requestAnimationFrame(() => { wartet = false; sync(); autoSchliessen(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'selected'] });
  sync();
})();

/* Zuschnitt-Dialog: "Auswählen" erst freigeben, wenn das Bild im Cropper geladen ist (16.10.2026, Theme-Kopie PMP H 1610).
   Ohne diese Sperre meldet teeinblue bei einem Tipp in den ersten ca. 0,3 s "Dein Foto ist zu klein", weil der Cropper
   noch keine Maße hat. Der Knopf wird erst freigegeben, wenn Bild und Zuschnittrahmen da sind und sich 300 ms lang nichts
   mehr verändert, spätestens nach 5 s. */
(() => {
  'use strict';
  if (window.__pmpCropWartet) return;
  window.__pmpCropWartet = true;
  const MAX_MS = 5000;
  const st = document.createElement('style');
  st.textContent = '.pmp-crop-wartet{opacity:.45!important;cursor:default!important}';
  document.head.appendChild(st);
  let aktuell = null, frei = true, start = 0, timer = 0, sig = '', ruhig = 0;
  const knopf = () => document.querySelector('.tee-cropper-footer .tee-btn--primary');
  const bereit = () => {
    const imgs = [...document.querySelectorAll('.tee-cropper-body img')];
    if (!imgs.length || !imgs.every((i) => i.complete && i.naturalWidth > 0)) return false;
    const r = document.querySelector('.tee-cropper-body .vue-advanced-cropper__stencil-wrapper, .tee-cropper-body .vue-rectangle-stencil');
    if (!r || r.getBoundingClientRect().width <= 0) return false;
    const s = imgs.map((i) => { const x = i.getBoundingClientRect(); return [x.width, x.height, x.left, x.top].map(Math.round).join(','); }).join(';') + '|' + Math.round(r.getBoundingClientRect().width);
    if (s !== sig) { sig = s; ruhig = Date.now(); return false; }
    return Date.now() - ruhig >= 300;
  };
  const freigeben = () => {
    frei = true;
    clearInterval(timer); timer = 0;
    if (aktuell) { aktuell.classList.remove('pmp-crop-wartet'); aktuell.removeAttribute('aria-disabled'); }
  };
  const pruefen = () => {
    const b = knopf();
    if (!b || b !== aktuell) { freigeben(); aktuell = null; return; }
    if (bereit() || Date.now() - start > MAX_MS) freigeben();
  };
  const neu = () => {
    const b = knopf();
    if (!b || b === aktuell) return;
    aktuell = b; frei = false; start = Date.now(); sig = ''; ruhig = 0;
    b.classList.add('pmp-crop-wartet'); b.setAttribute('aria-disabled', 'true');
    clearInterval(timer); timer = setInterval(pruefen, 50);
    pruefen();
  };
  document.addEventListener('click', (e) => {
    if (!e.target.closest || !e.target.closest('.tee-cropper-footer .tee-btn--primary')) return;
    neu();   // Knopf ist neu (Beobachter noch nicht gelaufen): sofort sperren
    if (!frei) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  new MutationObserver(neu).observe(document.body, { childList: true, subtree: true });
})();
